import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
export default {
    methods: {
        /*支付，寄送*/
        getPay(type) {
            let params = { Sid: this.sysSid, Session: this.sysSession, ParmType: type };
            $http.get("api/Common/GetParmConfig", params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }
                });
            });
        },
        updateOrderData() {

            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                OrderId: this.Id,
                Consignee: this.OrderData.Consignee,
                ConsigneeTel: this.OrderData.ConsigneeTel,
                ProvincesId: this.OrderData.ProvincesId,
                CityId: this.OrderData.CityId,
                AreaId: this.OrderData.AreaId,
                Address: this.OrderData.AreaName,
                SendMode: this.OrderData.SendMode,
                AuditRemark: this.OrderData.AuditRemark
            };
            $http.post("api/Order/AuditTestClassOrderEx", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.$emit("showpage");
                });
            });

        },
        req_getOrderData() {
            let params = { Sid: this.sysSid, Session: this.sysSession, Id: this.Id };
            $http.get("api/Order/GetERP_OrderById", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.OrderData = Data;
                    this.areaInfo.Provinces_Id = this.OrderData.ProvincesId;
                    this.areaInfo.City_Id = this.OrderData.CityId;
                    this.areaInfo.Area_Id = this.OrderData.AreaId;
                    this.$store.dispatch("getRouterName", "试课审核查看");
                    let radioLegth = document.getElementsByClassName("is-checked").length;
                    if (radioLegth) {
                        for (var i = 0; i < radioLegth; i++) {
                            document.getElementsByClassName("is-checked")[i].childNodes[0].style.backgroundColor = "red"
                        }
                        // document.getElementsByClassName("el-radio__inner")[0].style.backgroundColor = "#4a7198"
                    }
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/components/viewtestclass/services.js